export default __webpack_public_path__ + "static/bask-f0e184c417d9c1444c38ddbee9762c9b.svg";